import {
    FETCH_PLAYERS_REQUEST,
    FETCH_PLAYERS_SUCCESS,
    FETCH_PLAYERS_FAILURE,
    CREATE_PLAYER_SUCCESS,
    UPDATE_PLAYER_SUCCESS,
    DELETE_PLAYER_SUCCESS,
    TOGGLE_LOCK_PLAYER_SUCCESS
  } from '../actions/playerActions';
  import { PATCH_PLAYER_BALANCE_AFTER_TRANSFER } from '../actions/transferBalancePatchActions';
  
  const initialState = {
    players: [],
    loading: false,
    error: null
  };
  
  const playerReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_PLAYERS_REQUEST:
        return { ...state, loading: true, error: null };
      case FETCH_PLAYERS_SUCCESS:
        return { ...state, loading: false, players: action.payload, error: null };
      case FETCH_PLAYERS_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case CREATE_PLAYER_SUCCESS:
        if (!action.payload) return state;
        return { ...state, players: [...state.players, action.payload] };
      case UPDATE_PLAYER_SUCCESS:
        return {
          ...state,
          players: state.players.map(player =>
            player._id === action.payload._id ? action.payload : player
          )
        };
      case DELETE_PLAYER_SUCCESS:
        return {
          ...state,
          players: state.players.filter(player => player._id !== action.payload)
        };
      case TOGGLE_LOCK_PLAYER_SUCCESS:
        return {
          ...state,
          players: state.players.map((player) =>
            player._id === action.payload?._id
              ? { ...player, isLocked: action.payload.isLocked, is_active: action.payload.is_active }
              : player
          )
        };
      case PATCH_PLAYER_BALANCE_AFTER_TRANSFER: {
        const { playerId, balance } = action.payload;
        if (playerId == null || balance == null) return state;
        return {
          ...state,
          players: state.players.map((p) =>
            String(p._id) === String(playerId) || String(p.username) === String(playerId)
              ? { ...p, balance }
              : p
          ),
        };
      }
      default:
        return state;
    }
  };
  
  export default playerReducer;